import React from "react";
import HeroBlogImg from "../assets/images/heroBlog.jpg";
import { blogPosts } from "../utils/blogData";
import { useNavigate } from "react-router-dom";

const HeroBlog = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col md:flex-row w-full bg-[#F6EEFF]">
      {/* Text Section */}
      <div className="md:w-2/5 w-full p-6 flex flex-col gap-4 justify-center">
        <p className="text-[#7B3BCC] font-medium">Blog of the Day</p>
        <h2 className="font-bold text-2xl md:text-3xl">{blogPosts[0].title}</h2>
        <p className="text-[#888888] text-sm md:text-base">
          {blogPosts[0].desc}
        </p>
        <p
          className="text-[#7B3BCC] font-semibold cursor-pointer hover:underline"
          onClick={() => navigate(`/blogs/${blogPosts[0].id}`)}
        >
          Read More
        </p>
      </div>

      {/* Image Section */}
      <div className="md:w-3/5 w-full">
        <img
          src={HeroBlogImg}
          alt="hero-blog"
          className="w-full h-full object-cover max-h-[400px] md:max-h-none"
        />
      </div>
    </div>
  );
};

export default HeroBlog;
